import { render, staticRenderFns } from "./KimsaTagsPicker.vue?vue&type=template&id=67a04f8a&scoped=true"
import script from "./KimsaTagsPicker.vue?vue&type=script&lang=js"
export * from "./KimsaTagsPicker.vue?vue&type=script&lang=js"
import style0 from "./KimsaTagsPicker.vue?vue&type=style&index=0&id=67a04f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a04f8a",
  null
  
)

export default component.exports